import HubspotForm from '../../real1031/newsletter-form';

const Real1031Home = () => {

    return (
        <div>
            <h1 className="text-center">Interested in deferring taxes with a 1031 exchange?</h1>
            <p>
                For over 25 years, Real1031 has served as a qualified intermediary during the 1031 exchange process, helping
                investors to defer capital gains tax on the sale of their business or investment property.
                <br /><br />
                If you are planning to sell real estate investment property and would like to defer potential capital gains and
                tax, you should consider the benefits of participating in a tax-deferred 1031 exchange. View our FAQs to learn
                more about the 1031 exchange process to review the most common questions about exchanges.
                <br /><br />
                <strong>There are many benefits to using Real1031:</strong>
            </p>
            <ul>
                <li>Ability to execute exchanges nation-wide</li>
                <li>With our Proceeds Protection Protocol, we treat your money like it's our own</li>
                <li>Tools and tips for Exchangors and Brokers</li>
                <li>Most valuable is our expertise. Our dedicated staff has extensive knowledge on a wide variety of topics</li>
            </ul>
            <p>
                Have questions? Real1031 offers complimentary consultations&mdash;Contact us today. We look forward to
                discussing strategies on deferring long term capital gains and more.
                <br /><br />
                <strong>Sign-up for our newsletter:</strong>
            </p>
            <HubspotForm portalId="6205670" formId="f1086f98-7910-4f91-8afa-5f6e8200e1cd" targetId="hs-form-newsletter" />
        </div>
    );
};

export default Real1031Home;
